<template>
    <div class="form-group">
        <div class="input-group mb-2">
            <div class="input-group-prepend">
                <div class="input-group-text">+998</div>
            </div>
            <input
                    :class="className"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    @input="handleInput"
                    @keypress.enter="onEnterCallback"
                    autocomplete="off"
                    class="form-control num"
                    v-model="userPhone">
        </div>
    </div>
</template>

<script>
    export default {
        name: "PhoneNumber",
        props: [
            'value',
            'onEnter',
            'disabled',
            'placeholder',
            'className'
        ],
        data() {
            return {
                userPhone: this.value
            }
        },
        methods: {
            handleInput() {
                if (!(/^\d*$/.test(this.userPhone))) this.userPhone = this.userPhone.replace(/[^0-9.]/g, "");
                if (this.userPhone.length > 9) this.userPhone = this.userPhone.substr(0, 9);
                this.$emit('input', this.userPhone);
            },
            onEnterCallback() {
                if (typeof this.onEnter === "function")
                    return this.onEnter();
            }
        },
        watch: {
            value: function(val) {
                this.userPhone = val
            }
        }
    }
</script>

<style scoped>

</style>